import type { InputHTMLAttributes, SelectHTMLAttributes } from "react";

/** `.search` control wrappers (U10). The raw CSS class carries
 *  `margin-left: auto` (a toolbar-era default), which forced 11 scattered
 *  `marginLeft: 0` overrides — and caused the bulk-allocate misalignment bug.
 *  These wrappers fix the default once; pass `style` for anything else. */

export function Select({ style, className, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  // merge className — a spread-through className must never REPLACE "search"
  // (that's how the History IMEI picker briefly lost its styling)
  return <select className={className ? `search ${className}` : "search"}
    style={{ marginLeft: 0, ...style }} {...rest} />;
}

export function SearchInput({ mono = false, style, className, ...rest }:
  InputHTMLAttributes<HTMLInputElement> & { mono?: boolean }) {
  // SAME merge as Select above, which had this fixed and this one did not.
  // `{...rest}` is spread LAST, so a caller's className did not merge with
  // "search" -- it REPLACED it, stripping the control's own styling while
  // type-checking perfectly. Silent, and invisible until you look at the page.
  const cls = [mono ? "search mono" : "search", className].filter(Boolean).join(" ");
  return <input className={cls} style={{ marginLeft: 0, ...style }} {...rest} />;
}
